import AbstractDexieClass from "../abstractClasses/AbstractDexieErrorLog";

export default class UnknowError extends AbstractDexieClass {
  constructor() {
    super("UnknowError", {
      employee: String,
      company: String,
      team: String,
      route: String,
      href: String,
      hint: String,
      errorString: String,
      timeStamp: Date,
    });
  }
}
